const Button = ({ buttonStyle='normal', disabled=false, onClick, label }) => {

    const getButtonStyle = (style) => {
        switch (style) {
            case 'normal':
                return 'bg-tgray text-tprimary w-full h-[52px] leading-[52px] rounded-[10px] text-center font-[500] text-[15px] rubik disabled:opacity-50 disabled:pointer-events-none transition-all hover:bg-nborder';
            case 'gray':
                return 'bg-white text-tprimary border-nborder border-[1px] w-full h-[50px] leading-[48px] rounded-[10px] text-center font-[500] text-[15px] rubik disabled:opacity-50 disabled:pointer-events-none transition-all hover:bg-tgray/40';
            default:
                return 'border-tprimary border-[1px] rounded-[5px] px-[15px] py-[10px]';
        }
    }

    return (
        <button type="button" onClick={!disabled ? onClick : null} disabled={disabled} className={getButtonStyle(buttonStyle)}>{label}</button>
    )

};

export default Button;
